import { api, useUser } from "@/services/auth-service";
import { useEffect, useState } from "react";

interface FeatureLimits {
  plan: string;
  maxStoriesPerDay: number;
  storyCharacters: number;
  artStyles: string[];
  allArtStyles: string[];
  maxTotalStories: number;
  currentUsage: any;
  storyCreate: any;
  subscriptionStatus: string;
}

export const useFeature = () => {
  const [limits, setLimits] = useState<FeatureLimits | null>(null);
  const user = useUser();

  useEffect(() => {
    const fetchLimits = async () => {
      try {
        const response = await api.get('/features/');
        setLimits(response.data);
      } catch (error) {
        console.error('Error fetching feature limits:', error);
      }
    };

    // Only fetch if we have a user with an email
    if (user?.email) {
      fetchLimits();
    }
  }, [user?.email]); // Depend on user.email instead of user object

  const checkFeatureAccess = async (feature: keyof FeatureLimits) => {
    const response = await api.get('/api/usage/check', { params: { feature } });
    return response.data.hasAccess;
  };

  return { limits, checkFeatureAccess };
};
